// import React, { useState, useEffect } from 'react';
// import ModalWrapper from './ModalWrapper'; // Import ModalWrapper
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import TimePicker from 'react-time-picker';
// import { BaseUrl } from '../../../Actions/Base';

// const AddClassPopup = ({ showAddClassPopup, setShowOwnTimeFields, instructorTypeExtracted, InstructorState, }) => {
//     const Days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
//     const [selectedDay, setSelectedDay] = useState('');
//     const [showModalbtn, setShowModalbtn] = useState(false);
//     // Initialize time states with defaults
//     const [startTime, setStartTime] = useState('09:00'); // Default start time
//     const [endTime, setEndTime] = useState('10:00');     // Default end time
//     const [error, setError] = useState('');

//     const handleSelectDay = (e) => {
//         setSelectedDay(e.target.value);
//     };

//     // Figure out which index in InstructorState corresponds to instructorTypeExtracted:
//     const typeToIndex = {
//         Driving: 0,
//         Online: 1,
//         InClass: 2,
//     };
//     const idx = typeToIndex[instructorTypeExtracted] ?? 0;

//     // Grab that instructor’s data (or a default empty object if none yet)
//     const chosenInstructor = InstructorState[idx] || {};

//     // If you stored "InstructorImage" as a relative path, you might need to prepend BaseUrl or similar:
//     const instructorImgSrc = chosenInstructor.InstructorImage
//         ? `${BaseUrl}/api/images/Instructors?url=${chosenInstructor.InstructorImage}`
//         : null;

//     const instructorFullName = chosenInstructor.InstructorName || "";

//     return (
//         <ModalWrapper isOpen={showAddClassPopup} onClose={() => {
//             setShowOwnTimeFields(false); 
//           }} showModalbtn={showModalbtn}>
//           <p className='text-[26px] text-[#4C34AD] font-semibold'>Custom Time Schedule ({instructorTypeExtracted})</p>

//           <div className='mt-[10px] w-full rounded-[12px] p-[20px] flex gap-[20px] items-center'
//           style={{ border: '1px solid #B7B7B7' }}>
//                 <img
//                     className="w-[55px] h-[55px] rounded-full "
//                     src={instructorImgSrc}
//                     alt=""
//                 />
//                 <p className="text-[23px]">{instructorFullName}</p>
//           </div>

//           <div className='mt-[10px] w-full rounded-[12px]'
//           style={{ border: '1px solid #B7B7B7' }}>
//             <div 
//              style={{ borderBottom: '1px solid #B7B7B7' }}>
//                 <div className='flex gap-[5px] px-[15px] pt-[15px] pb-[10px]'>
//                 <AccessTimeIcon />
//                 <p className='text-[19px] text-[#333333] font-semibold'>Date And Time</p>
//                 </div>
//             </div>
//             <div className='flex flex-col py-[15px] px-[20px] gap-[15px]'>
//                 <div className='flex items-center gap-[43px]'>
//                     <p className='text-[19px] text-[#333333] font-semibold'>On</p>
//                     <select
//                     value={selectedDay}
//                     onChange={handleSelectDay}
//                     className="rounded-[13px] border-0" // Removes default border
//                     style={{
//                         width: '89%',
//                         height: '50px', // Sets the height to 50px
//                         border: '2px solid #D7D9FF', // Sets the border color and width
//                         outline: 'none', // Optional: removes default outline on focus
//                         padding: '0 10px', // Optional: adds horizontal padding for better appearance
//                     }}
//                 >
//                     <option value="">Select a day</option>
//                     {Days.map((day) => (
//                         <option key={day} value={day}>{day}</option>
//                     ))}
//                     </select>
//                 </div>

//                 <div className='flex items-center gap-[20px]'>
//                     <p className='text-[19px] text-[#333333] font-semibold'>From</p>
//                     <TimePicker
//                         onChange={setStartTime}
//                         value={startTime}
//                         disableClock
//                         clearIcon={null}
//                         format="h:mm a"
//                         className="custom-time-picker"
//                     />
//                 </div>

//                 <div className='flex items-center gap-[45px]'>
//                     <p className='text-[19px] text-[#333333] font-semibold'>To</p>
//                     <TimePicker
//                         onChange={setEndTime}
//                         value={endTime}
//                         disableClock
//                         clearIcon={null}
//                         format="h:mm a"
//                         className="custom-time-picker"
//                     />
//                 </div>

//                 <div className='mt-[10px] w-full flex justify-center items-center gap-[20px]'>
//                 <button
//                 type="button"
//                 className="rounded-[10px]  w-[121px]  h-[42px] text-[#4C34AD] text-[19px] "
//                 style={{ border: '2px solid #4C34AD' }}
//                         onClick={() => {
//                     setShowOwnTimeFields(false); 
//                 }}
//                 >
//                     Cancel
//                 </button>

//                 <button type="button"
//                 className=" rounded-[10px] bg-[#4C34AD] w-[121px]  h-[42px] text-[19px] text-[#FFFFFF] "
//                 >
//                     Add Class
//                 </button>
//             </div>
//             </div>
//           </div>
//         </ModalWrapper>
//     );
// };

// export default AddClassPopup;


import React, { useState, useRef } from 'react';
import ModalWrapper from './ModalWrapper';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimePicker from 'react-time-picker';
import { BaseUrl } from '../../../Actions/Base';
import ReactSelect from "react-select"; // renamed to avoid conflict

const AddClassPopup = ({
    showAddClassPopup,
    setShowOwnTimeFields,
    instructorTypeExtracted,
    InstructorState,
    setCombinedEvents,
    instituteClasses,
    studentScheduleEvents,
    setAddClassEvents,
    addClassEvents,
    CoursePackage,
    timeSlots,
    selectedDate,
    selectedDay,
    setSelectedDay,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    handleAddClass,
    error,
    setError,
    isSeparateSchedule,
    handleSeparateScheduleAddClass
}) => {
  const Days = [...new Set(timeSlots?.map(slot => slot.DayOfWeek))];
  console.log("Days in AddClassPopup is:",Days);
  console.log("selectedDate in add class is:",selectedDate)

  const reactSelectDayOptions = Days.map((day) => ({ label: day, value: day }));

  // const [selectedDay, setSelectedDay] = useState([]);
  // const [startTime, setStartTime] = useState('09:00');
  // const [endTime, setEndTime] = useState('10:00');
  // const [error, setError] = useState('');
  const [recurringTemplates, setRecurringTemplates] = useState([]); // for future use
  const recurringTemplatesRef = useRef([]);

  const typeToIndex = {
    Driving: 0,
    Online: 1,
    InClass: 2,
  };
  const typeColors = {
    Driving: '#0AA630',
    Online: '#FC0000',
    InClass: '#1F7BF4',
  };

  // Pull hours from CoursePackage
  // const { 
  //   DrivingHours  = 0, 
  //   InClassHours  = 0, 
  //   OnlineHours   = 0 
  // } = CoursePackage || {};

  const idx = typeToIndex[instructorTypeExtracted] ?? 0;
  const chosenInstructor = InstructorState[idx] || {};
  console.log("chosenInstructor in add class is:",chosenInstructor)
  const instructorImgSrc = chosenInstructor.InstructorImage
    ? `${BaseUrl}/api/images/Instructors?url=${chosenInstructor.InstructorImage}`
    : null;

  const instructorFullName = chosenInstructor.InstructorName || "";
  const instructorId = chosenInstructor?.InstructorFK || "";

  // const generateRecurringClasses = ({
  //   dayTimeCombos,
  //   instructorType,
  //   instructorId,
  //   instructorName,
  //   totalHours,
  //   startDate = new Date(),
  //   existingClassesLength = 0
  // }) => {
  //   const typeColors = {
  //     Driving: '#0AA630',
  //     Online: '#FC0000',
  //     InClass: '#1F7BF4',
  //   };
  
  //   const dayNameToIndex = {
  //     Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3,
  //     Thursday: 4, Friday: 5, Saturday: 6,
  //   };
  
  //   const groupedCombos = {};
  //   for (const combo of dayTimeCombos) {
  //     const dayIndex = dayNameToIndex[combo.day];
  //     if (!groupedCombos[dayIndex]) groupedCombos[dayIndex] = [];
  //     groupedCombos[dayIndex].push({ ...combo, dayIndex });
  //   }
  
  //   const sortedDayIndexes = Object.keys(groupedCombos).map(Number).sort((a, b) => a - b);
  
  //   const events = [];
  //   let hoursScheduled = 0;
  //   let weekOffset = 0;
  
  //   while (hoursScheduled < totalHours) {
  //     for (const dayIndex of sortedDayIndexes) {
  //       const combosForDay = groupedCombos[dayIndex];
  //       for (const combo of combosForDay) {
  //         if (hoursScheduled >= totalHours) break;
  
  //         const weekStart = new Date(startDate);
  //         weekStart.setDate(weekStart.getDate() + weekOffset * 7);
  //         weekStart.setHours(0, 0, 0, 0);
  
  //         const dayDiff = (dayIndex - weekStart.getDay() + 7) % 7;
  //         const classDate = new Date(weekStart);
  //         classDate.setDate(classDate.getDate() + dayDiff);
  
  //         const fullStart = new Date(`${classDate.toDateString()} ${combo.startTime}`);
  //         const fullEnd = new Date(`${classDate.toDateString()} ${combo.endTime}`);
  
  //         const slotDuration = (fullEnd - fullStart) / (1000 * 60 * 60);
  //         const remainingHours = totalHours - hoursScheduled;
  //         const classDuration = Math.min(slotDuration, remainingHours);
  
  //         const classEnd = new Date(fullStart.getTime() + classDuration * 60 * 60 * 1000);
  
  //         const event = {
  //           allDay: false,
  //           Subject: `${combo.day} Class`,
  //           StartTime: fullStart,
  //           EndTime: classEnd,
  //           startDate: fullStart,
  //           endDate: classEnd,
  //           start: fullStart.toISOString(),
  //           end: classEnd.toISOString(),
  //           text: '',
  //           ClassType: instructorType,
  //           Instructors: instructorId,
  //           event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
  //           ClassNo: existingClassesLength + events.length + 1,
  //           CategoryColor: typeColors[instructorType] || '#000000',
  //           InstructorName: instructorName,
  //         };
  
  //         events.push(event);
  //         hoursScheduled += classDuration;
  
  //         if (hoursScheduled >= totalHours) break;
  //       }
  //     }
  
  //     weekOffset++;
  //   }
  
  //   return events;
  // };
  
  // const handleAddClass = () => {
  //   if (!selectedDay.length || !startTime || !endTime) {
  //     setError('Please select at least one day and both start/end time.');
  //     return;
  //   }
  
  //   const totalHoursByType = {
  //     Driving: DrivingHours,
  //     Online: OnlineHours,
  //     InClass: InClassHours,
  //   };
  
  //   const totalHours = totalHoursByType[instructorTypeExtracted] || 0;
  
  //   const remainingEvents = addClassEvents.filter(
  //     event => event.ClassType !== instructorTypeExtracted
  //   );
  
  //   const previousCombos = addClassEvents
  //     .filter(event => event.ClassType === instructorTypeExtracted)
  //     .map(event => {
  //       const day = new Date(event.startDate).toLocaleDateString('en-US', { weekday: 'long' });
  //       const startTime = new Date(event.startDate).toTimeString().slice(0, 5);
  //       const endTime = new Date(event.endDate).toTimeString().slice(0, 5);
  //       return { day, startTime, endTime };
  //     });
  
  //   const newCombos = selectedDay.map(day => ({ day, startTime, endTime }));
  
  //   const comboKey = combo => `${combo.day}-${combo.startTime}-${combo.endTime}`;
  //   const combinedCombosMap = new Map();
  
  //   [...previousCombos, ...newCombos].forEach(combo => {
  //     combinedCombosMap.set(comboKey(combo), combo);
  //   });
  
  //   const mergedCombos = Array.from(combinedCombosMap.values());
  
  //   const newClasses = generateRecurringClasses({
  //     dayTimeCombos: mergedCombos,
  //     instructorType: instructorTypeExtracted,
  //     instructorId,
  //     instructorName: instructorFullName,
  //     totalHours,
  //     existingClassesLength: remainingEvents.length,
  //   });
  
  //   const updatedAddClassEvents = [...remainingEvents, ...newClasses];
  //   setAddClassEvents(updatedAddClassEvents);
  //   setCombinedEvents([
  //     ...studentScheduleEvents,
  //     ...instituteClasses,
  //     ...updatedAddClassEvents,
  //   ]);
  
  //   setShowOwnTimeFields(false);
  // };

  
  return (
    <ModalWrapper isOpen={showAddClassPopup} onClose={() => setShowOwnTimeFields(false)}>
      <p className='text-[26px] text-[#4C34AD] font-semibold'>
        Custom Time Schedule ({instructorTypeExtracted})
      </p>

      <div className='mt-[10px] w-full rounded-[12px] p-[20px] flex gap-[20px] items-center' style={{ border: '1px solid #B7B7B7' }}>
        <img className="w-[55px] h-[55px] rounded-full" src={instructorImgSrc} alt="" />
        <p className="text-[23px]">{instructorFullName}</p>
      </div>

      <div className='mt-[10px] w-full rounded-[12px]' style={{ border: '1px solid #B7B7B7' }}>
        <div style={{ borderBottom: '1px solid #B7B7B7' }}>
          <div className='flex items-center gap-[5px] px-[15px] mt-[15px] mb-[10px]'>
            <AccessTimeIcon />
            <p className='text-[19px] text-[#333333] font-semibold'>Day And Time</p>
          </div>
        </div>
        <div className='flex flex-col py-[15px] px-[20px] gap-[15px]'>
          <div className='flex items-center gap-[43px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>On</p>
            <div className='w-full'>
              <ReactSelect 
                options={reactSelectDayOptions}
                isMulti
                placeholder="Select Days"
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions.map((opt) => opt.value);
                  setSelectedDay(selectedValues);
                }}
                value={reactSelectDayOptions.filter(opt => selectedDay.includes(opt.value))}
                styles={{
                          control: (base, state) => ({
                              ...base,
                              width: '100%',
                              paddingTop: '5px',    // py-2
                              paddingBottom: '5px',
                              paddingLeft: '10px',     // px-[10px]
                              paddingRight: '10px',
                              borderRadius: '0.375rem', // rounded-md
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)', // shadow-md
                              border: state.isFocused ? '1px solid #60A5FA' : '1px solid #d1d5db', // Tailwind border/gray-300
                              '&:hover': {
                                  borderColor: '#60A5FA',
                              },
                          }),
                          multiValue: (base) => ({
                              ...base,
                              backgroundColor: '#E5E7EB', // gray-200
                          }),
                          multiValueLabel: (base) => ({
                              ...base,
                              color: '#374151', // gray-700
                          }),
                          multiValueRemove: (base) => ({
                              ...base,
                              color: '#6B7280', // gray-500
                              ':hover': {
                                  backgroundColor: '#F87171', // red-400
                                  color: 'white',
                              },
                          }),
                      }}
              />
            </div>

          </div>

          <div className='flex items-center gap-[20px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>From</p>
            <TimePicker
              onChange={setStartTime}
              value={startTime}
              disableClock
              clearIcon={null}
              format="h:mm a"
              className="custom-time-picker"
            />
          </div>

          <div className='flex items-center gap-[45px]'>
            <p className='text-[19px] text-[#333333] font-semibold'>To</p>
            <TimePicker
              onChange={setEndTime}
              value={endTime}
              disableClock
              clearIcon={null}
              format="h:mm a"
              className="custom-time-picker"
            />
          </div>

          {error && <p className="text-[#FF0000]">{error}</p>}

          <div className='mt-[10px] w-full flex justify-center items-center gap-[20px]'>
            <button
              type="button"
              className="rounded-[10px] w-[121px] h-[42px] text-[#4C34AD] text-[19px]"
              style={{ border: '2px solid #4C34AD' }}
              onClick={() => setShowOwnTimeFields(false)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="rounded-[10px] bg-[#4C34AD] w-[121px] h-[42px] text-[19px] text-white"
              // onClick={handleAddClass}
              onClick={() => {
                isSeparateSchedule ? handleSeparateScheduleAddClass() : handleAddClass();
              }}
            >
              Add Class
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AddClassPopup;

 {/* <select
              value={selectedDay}
              onChange={(e) => setSelectedDay(e.target.value)}
              className="rounded-[13px] border-0"
              style={{
                width: '89%',
                height: '50px',
                border: '2px solid #D7D9FF',
                outline: 'none',
                padding: '0 10px',
              }}
            >
              <option value="">Select a day</option>
              {Days.map((day) => (
                <option key={day} value={day}>{day}</option>
              ))}
            </select> */}



 // const newClass = {
    //   Id: `custom-${Date.now()}`, // unique id
    //   Subject: `Custom ${instructorTypeExtracted} Class`,
    //   StartTime: startDate,
    //   EndTime: endDate,
    //   CategoryColor: typeColors[instructorTypeExtracted] || '#000000',
    //   InstructorName: instructorFullName,
    //   ClassType: instructorTypeExtracted,
    // };



    //   const handleAddClass = () => {
//     // 1. Validation
//     if (!selectedDay || !startTime || !endTime) {
//       setError('Please select a day and both start/end time.');
//       return;
//     }
//     setError('');

//     // 2. Create start and end Date objects for the current week
//     const baseDate = getNextDateOfDay(selectedDay);
//     const [startHour, startMin] = startTime.split(':');
//     const [endHour, endMin] = endTime.split(':');

//     const startDate = new Date(baseDate);
//     startDate.setHours(+startHour, +startMin, 0, 0);  // zero seconds and ms

//     const endDate = new Date(baseDate);
//     endDate.setHours(+endHour, +endMin, 0, 0);        // zero seconds and ms

//     // 3. Create new class event object
//     const newClass = {
//         allDay: false,
//         Subject: `${selectedDay} Class`, // ✅ Syncfusion expects this
//         StartTime: startDate,            // ✅ Syncfusion expects this
//         EndTime: endDate,                // ✅ Syncfusion expects this
//         startDate: startDate,
//         endDate: endDate,
//         start: startDate.toISOString(),
//         end: endDate.toISOString(),
//         text: '',
//         ClassType: instructorTypeExtracted,
//         Instructors: instructorId,
//         event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
//         ClassNo: addClassEvents.length + 1,
//         CategoryColor: typeColors[instructorTypeExtracted] || '#000000',
//         InstructorName: instructorFullName,
//       };
      
      
//     console.log("newClass is:",newClass)
//     // 4. Add to existing events
//     const updatedAddClassEvents = [...addClassEvents, newClass];

//     setAddClassEvents(updatedAddClassEvents);
//     setCombinedEvents([
//     ...studentScheduleEvents,
//     ...instituteClasses,
//     ...updatedAddClassEvents,
//     ]);
      
//     // 5. Close modal
//     setShowOwnTimeFields(false);
//   };



//   const handleAddClass = () => {
//     if (!selectedDay || !startTime || !endTime) {
//       setError('Please select a day and both start/end time.');
//       return;
//     }
//     setError('');
  
//     const baseDate = getNextDateOfDay(selectedDay);
//     const [startHour, startMin] = startTime.split(':');
//     const [endHour, endMin] = endTime.split(':');
  
//     const startDate = new Date(baseDate);
//     startDate.setHours(+startHour, +startMin, 0, 0);
  
//     const endDate = new Date(baseDate);
//     endDate.setHours(+endHour, +endMin, 0, 0);
  
//     const durationPerClass = getDurationInHours(startDate, endDate); // e.g., 2 hours
  
//     const classType = instructorTypeExtracted;
//     const totalRequiredHours = CoursePackage[`${classType}Hours`] || 0;
  
//     const alreadyAddedHours = addClassEvents
//       .filter(evt => evt.ClassType === classType)
//       .reduce((sum, evt) => sum + getDurationInHours(evt.StartTime, evt.EndTime), 0);
  
//     const remainingHours = totalRequiredHours - alreadyAddedHours;
  
//     const weeklySlots = [];
  
//     let nextDate = new Date(startDate);
//     let currentHours = 0;
//     let counter = 0;
  
//     while (currentHours + durationPerClass <= remainingHours) {
//       const slotStart = new Date(nextDate);
//       const slotEnd = new Date(nextDate);
//       slotEnd.setHours(slotStart.getHours() + durationPerClass);
  
//       weeklySlots.push({
//         allDay: false,
//         Subject: `${selectedDay} Class`,
//         StartTime: slotStart,
//         EndTime: slotEnd,
//         startDate: slotStart,
//         endDate: slotEnd,
//         start: slotStart.toISOString(),
//         end: slotEnd.toISOString(),
//         text: '',
//         ClassType: classType,
//         Instructors: instructorId,
//         event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}-${counter++}`,
//         ClassNo: addClassEvents.length + counter,
//         CategoryColor: typeColors[classType] || '#000000',
//         InstructorName: instructorFullName,
//       });
  
//       currentHours += durationPerClass;
  
//       // Move to next week's same day
//       nextDate.setDate(nextDate.getDate() + 7);
//     }
  
//     const updatedAddClassEvents = [...addClassEvents, ...weeklySlots];
  
//     setAddClassEvents(updatedAddClassEvents);
//     setCombinedEvents([
//       ...studentScheduleEvents,
//       ...instituteClasses,
//       ...updatedAddClassEvents,
//     ]);
  
//     setShowOwnTimeFields(false);
//   };  



//   const generateAllSlots = (templates) => {
//     const classType = instructorTypeExtracted;
//     const totalRequiredHours = CoursePackage[`${classType}Hours`] || 0;
  
//     const existingHours = addClassEvents
//       .filter(evt => evt.ClassType === classType)
//       .reduce((sum, evt) => sum + getDurationInHours(evt.StartTime, evt.EndTime), 0);
  
//     let remainingHours = totalRequiredHours - existingHours;
//     if (remainingHours <= 0) return;
  
//     const allNewEvents = [];
//     let counter = 0;
  
//     // Create a date cursor for each template
//     const dateCursors = templates.map(template => ({
//       ...template,
//       currentDate: getNextDateOfDay(template.day),
//     }));
  
//     while (remainingHours > 0) {
//       for (const t of dateCursors) {
//         const [startHour, startMin] = t.startTime.split(':');
//         const [endHour, endMin] = t.endTime.split(':');
  
//         const slotStart = new Date(t.currentDate);
//         slotStart.setHours(+startHour, +startMin, 0, 0);
  
//         const slotEnd = new Date(t.currentDate);
//         slotEnd.setHours(+endHour, +endMin, 0, 0);
  
//         const duration = getDurationInHours(slotStart, slotEnd);
  
//         if (duration <= remainingHours) {
//           allNewEvents.push({
//             allDay: false,
//             Subject: `${t.day} Class`,
//             StartTime: slotStart,
//             EndTime: slotEnd,
//             startDate: slotStart,
//             endDate: slotEnd,
//             start: slotStart.toISOString(),
//             end: slotEnd.toISOString(),
//             text: '',
//             ClassType: classType,
//             Instructors: instructorId,
//             event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}-${counter++}`,
//             ClassNo: addClassEvents.length + counter,
//             CategoryColor: typeColors[classType] || '#000000',
//             InstructorName: instructorFullName,
//           });
  
//           remainingHours -= duration;
//         }
  
//         // Move this template's date to next week's same day
//         t.currentDate.setDate(t.currentDate.getDate() + 7);
//       }
//     }
  
//     const updatedAddClassEvents = [...addClassEvents, ...allNewEvents];
//     setAddClassEvents(updatedAddClassEvents);
//     setCombinedEvents([
//       ...studentScheduleEvents,
//       ...instituteClasses,
//       ...updatedAddClassEvents,
//     ]);
  
//     // Close modal
//     setShowOwnTimeFields(false);
//   };



// const handleAddClass = () => {
//   if (!selectedDay.length || !startTime || !endTime) {
//     setError('Please select at least one day and both start/end time.');
//     return;
//   }

//   setError('');

//   const newTemplate = {
//     day: selectedDay,
//     startTime,
//     endTime,
//   };

//   // Prevent duplicates
//   const alreadyExists = recurringTemplatesRef.current.some(
//     t =>
//       t.day === newTemplate.day &&
//       t.startTime === newTemplate.startTime &&
//       t.endTime === newTemplate.endTime
//   );

//   if (alreadyExists) {
//     setError('This time slot already exists.');
//     return;
//   }

//   recurringTemplatesRef.current.push(newTemplate);

//   // Just regenerate all events from all templates
//   generateAllSlots(recurringTemplatesRef.current);
// };
  



// 13 june
// const generateRecurringClasses = ({
  //   dayTimeCombos,
  //   instructorType,
  //   instructorId,
  //   instructorName,
  //   totalHours,
  //   startDate = new Date(),
  //   existingClassesLength = 0
  // }) => {
  //   console.log("⚙️ Generating recurring classes for:", {
  //     instructorType, instructorId, instructorName, totalHours,
  //     dayTimeCombos, existingClassesLength
  //   });
  
  //   const typeColors = {
  //     Driving: '#0AA630',
  //     Online: '#FC0000',
  //     InClass: '#1F7BF4',
  //   };
  
  //   const dayNameToIndex = {
  //     Sunday: 0,
  //     Monday: 1,
  //     Tuesday: 2,
  //     Wednesday: 3,
  //     Thursday: 4,
  //     Friday: 5,
  //     Saturday: 6,
  //   };
  
  //   const slotDuration = (
  //     new Date(`1970-01-01T${dayTimeCombos[0].endTime}`) -
  //     new Date(`1970-01-01T${dayTimeCombos[0].startTime}`)
  //   ) / (1000 * 60 * 60);
  
  //   const totalClasses = Math.ceil(totalHours / slotDuration);
  //   console.log("📏 Slot duration:", slotDuration, "hours");
  //   console.log("🎯 Total classes to generate:", totalClasses);
  
  //   const events = [];
  //   let count = 0;
  
  //   // Normalize combos
  //   const normalizedCombos = dayTimeCombos.map(combo => ({
  //     ...combo,
  //     dayIndex: dayNameToIndex[combo.day],
  //   }));
  
  //   let currentWeekStart = new Date(startDate);
  //   currentWeekStart.setHours(0, 0, 0, 0); // reset to start of day
  
  //   while (count < totalClasses) {
  //     // For each weekly pattern
  //     for (const combo of normalizedCombos) {
  //       if (count >= totalClasses) break;
  
  //       const comboDayIndex = combo.dayIndex;
  
  //       // Clone and move to correct weekday
  //       const classDate = new Date(currentWeekStart);
  //       const dayDiff = (comboDayIndex - classDate.getDay() + 7) % 7;
  //       classDate.setDate(classDate.getDate() + dayDiff);
  
  //       const startDateTime = new Date(
  //         classDate.toDateString() + ' ' + combo.startTime
  //       );
  //       const endDateTime = new Date(
  //         classDate.toDateString() + ' ' + combo.endTime
  //       );
  
  //       const event = {
  //         allDay: false,
  //         Subject: `${combo.day} Class`,
  //         StartTime: startDateTime,
  //         EndTime: endDateTime,
  //         startDate: startDateTime,
  //         endDate: endDateTime,
  //         start: startDateTime.toISOString(),
  //         end: endDateTime.toISOString(),
  //         text: '',
  //         ClassType: instructorType,
  //         Instructors: instructorId,
  //         event_id: `${Date.now()}-${Math.floor(Math.random() * 10000)}`,
  //         ClassNo: existingClassesLength + count + 1,
  //         CategoryColor: typeColors[instructorType] || '#000000',
  //         InstructorName: instructorName,
  //       };
  
  //       console.log(`🗓️ Added class ${count + 1}:`, event);
  //       events.push(event);
  //       count++;
  //     }
  
  //     // Move to next week
  //     currentWeekStart.setDate(currentWeekStart.getDate() + 7);
  //   }
  
  //   console.log("✅ Total events created:", events.length);
  //   return events;
  // };
   
  // const handleAddClass = () => {
  //   console.log('--- handleAddClass called ---');
  //   if (!selectedDay.length || !startTime || !endTime) {
  //     setError('Please select at least one day and both start/end time.');
  //     console.error('Missing fields:', { selectedDay, startTime, endTime });
  //     return;
  //   }
  
  //   const totalHoursByType = {
  //     Driving: DrivingHours,
  //     Online: OnlineHours,
  //     InClass: InClassHours,
  //   };
  
  //   const totalHours = totalHoursByType[instructorTypeExtracted] || 0;
  //   console.log('Total hours:', totalHours, 'for type:', instructorTypeExtracted);
  
  //   // Step 1
  //   const remainingEvents = addClassEvents.filter(
  //     event => event.ClassType !== instructorTypeExtracted
  //   );
  //   console.log('Remaining Events (excluding current type):', remainingEvents);
  
  //   // Step 2
  //   const previousCombos = addClassEvents
  //     .filter(event => event.ClassType === instructorTypeExtracted)
  //     .map(event => {
  //       const day = new Date(event.startDate).toLocaleDateString('en-US', { weekday: 'long' });
  //       const startTime = new Date(event.startDate).toTimeString().slice(0, 5);
  //       const endTime = new Date(event.endDate).toTimeString().slice(0, 5);
  //       return { day, startTime, endTime };
  //     });
  //   console.log('Previous Combos:', previousCombos);
  
  //   // Step 3
  //   const newCombos = selectedDay.map(day => ({
  //     day,
  //     startTime,
  //     endTime,
  //   }));
  //   console.log('New Combos:', newCombos);
  
  //   // Step 4
  //   const comboKey = combo => `${combo.day}-${combo.startTime}-${combo.endTime}`;
  //   const combinedCombosMap = new Map();
  
  //   [...previousCombos, ...newCombos].forEach(combo => {
  //     console.log('Adding combo to map:', comboKey(combo));
  //     combinedCombosMap.set(comboKey(combo), combo);
  //   });
  
  //   const mergedCombos = Array.from(combinedCombosMap.values());
  //   console.log('Merged Combos (no duplicates):', mergedCombos);
  
  //   // Step 5
  //   const newClasses = generateRecurringClasses({
  //     dayTimeCombos: mergedCombos,
  //     instructorType: instructorTypeExtracted,
  //     instructorId,
  //     instructorName: instructorFullName,
  //     totalHours,
  //     existingClassesLength: remainingEvents.length,
  //   });
  
  //   console.log('Generated new classes:', newClasses);
  
  //   const updatedAddClassEvents = [...remainingEvents, ...newClasses];
  //   console.log('Updated class events:', updatedAddClassEvents);
  
  //   setAddClassEvents(updatedAddClassEvents);
  //   setCombinedEvents([
  //     ...studentScheduleEvents,
  //     ...instituteClasses,
  //     ...updatedAddClassEvents,
  //   ]);
  
  //   setShowOwnTimeFields(false);
  //   console.log('--- handleAddClass finished ---');
  // };
  